module.exports = __webpack_public_path__ + "fonts/ClearSans-Thin-webfont7e0d3aeb3163a0f5a9d80da0549a0367.eot";